<template>
  <v-container fluid>
    <v-card flat raised elevation="5" style="width: 100%">
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12" md="12" class="pa-0">
            <v-row no-gutters v-resize="onResize">
              <ejs-splitter
                id="splitter"
                ref="splitterObj"
                :separatorSize="1"
                class="splitterContent"
                width="100%"
                :height="screenHeight"
              >
                <e-panes>
                  <e-pane
                    cssClass="overflow-y-hidden list-pane"
                    size="30%"
                    :collapsible="false"
                    :collapsed="false"
                    content="#agenda-list-content"
                    min="20%"
                  ></e-pane>
                  <e-pane
                    cssClass="overflow-y-hidden overflow-x-hidden table-pane"
                    size="70%"
                    min="50%"
                    content="#agenda-permission-content"
                  ></e-pane>
                </e-panes>
              </ejs-splitter>
              <div id="agenda-list-content">
                <v-toolbar
                  tile
                  flat
                  height="50"
                  color="neutralGray"
                  style="
                    color: #ffffff !important;
                    border-bottom: 1px solid var(--v-secondary-base) !important;
                  "
                >
                  <v-row
                    no-gutters
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <v-col cols="12" sm="1" md="1" xs="3">
                      <v-icon size="20" color="#FFFFFF" left
                        >mdi-view-agenda</v-icon
                      >
                    </v-col>
                    <v-col cols="12" sm="4" md="8" xs="6">
                      <span class="title">
                        {{ $t("agendas") }}
                      </span>
                    </v-col>
                    <v-col class="ml-auto" cols="12" sm="6" md="3" xs="3">
                      <a-btn
                        class="ml-auto"
                        small
                        text
                        dark
                        style="
                          color: #ffffff !important;
                          border: 1px solid #ffffff;
                          background: transperent;
                        "
                        @click.stop="sortingAgenda()"
                      >
                        <span>
                          {{ $t("title") }}
                          <v-icon
                            v-if="sortingType === 'ascending'"
                            size="16"
                            color="#FFFFFF"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon v-else size="16" color="#FFFFFF"
                            >mdi-arrow-down</v-icon
                          >
                        </span>
                      </a-btn>
                    </v-col>
                  </v-row>
                </v-toolbar>
                <v-skeleton-loader
                  v-if="sortedList.length == 0 && loaderLoading"
                  type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item"
                ></v-skeleton-loader>
                <a-list
                  v-else
                  :height="listHeight"
                  class="list-margin pt-0"
                  style="overflow: auto"
                >
                  <v-list-item-group v-model="selectedItem" color="primary">
                    <v-list-item
                      class="agenda-list"
                      v-for="(agendaItem, i) in sortedList"
                      :key="i"
                      @click="onAgendaItemClick(agendaItem)"
                    >
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-content v-on="on" v-bind="attrs">
                            <v-list-item-title>
                              {{ agendaItem.agendaName }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <span> {{ agendaItem.agendaName }} </span>
                      </v-tooltip>

                      <v-list-item-action>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-list-item-icon v-bind="attrs" v-on="on">
                              <v-icon size="20"> mdi-attachment </v-icon>
                              <v-list-item-action-text>{{
                                agendaItem.documentCount
                              }}</v-list-item-action-text>
                            </v-list-item-icon>
                          </template>
                          <span>
                            {{
                              $t("documents.tipAgendaDocContains", {
                                count: agendaItem.documentCount,
                              })
                            }}
                          </span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </a-list>
              </div>
              <div id="agenda-permission-content">
                <v-toolbar color="secondary" height="50" flat dense dark>
                  <v-row
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <v-col cols="12" sm="8" md="8">
                      <v-btn
                        text
                        dark
                        @click="onOpenDocumentUploadDialog"
                        v-if="false"
                      >
                        <v-icon left>mdi-upload</v-icon>
                        {{ $t("documents.upload") }}
                      </v-btn>
                      <v-btn text dark v-if="false" @click="onDeleteDocuments">
                        <v-icon left>mdi-delete</v-icon>
                        {{ $t("documents.delete") }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" style="padding-left: 4%">
                      <search-input v-model="search" :label="$t('lblSearchTextDocumentAgenda')" :labelTooltip="$t('lblSearchTextDocumentAgendaTooltip')"></search-input>
                    </v-col>
                  </v-row>
                </v-toolbar>
                <v-row
                  class="py-4 px-4"
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <v-col cols="12" sm="3" md="3">
                    <v-tooltip
                      bottom
                      v-if="
                        selectedAgendaItem &&
                        $security.checkMeetingTypeAccess(
                          selectedAgendaItem.meetingTypeId,
                          'OpenMeetingDocument'
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a-btn
                          v-bind="attrs"
                          v-on="on"
                          text
                          dark
                          v-if="
                            selectedAgendaItem &&
                            $security.checkMeetingTypeAccess(
                              selectedAgendaItem.meetingTypeId,
                              'OpenMeetingDocument'
                            )
                          "
                          :class="
                            selectedFiles.length > 0
                              ? 'primaryDark'
                              : 'secondary'
                          "
                          :disabled="selectedFiles.length > 0 ? false : true"
                          :style="
                            selectedFiles.length > 0
                              ? ''
                              : 'color: #EEEEEE !important'
                          "
                          @click.stop="downloadDocument"
                        >
                          <v-icon
                            left
                            :style="
                              selectedFiles.length > 0
                                ? ''
                                : 'color: #FFFFFF !important'
                            "
                            >mdi-download</v-icon
                          >
                          {{ $t("documents.download") }}
                        </a-btn>
                      </template>
                      <span>{{ $t("documents.tipDownload") }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"></v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    class="text-right"
                    style="margin: auto"
                  >
                    <v-chip
                      v-if="selectedFiles.length > 0"
                      close
                      label
                      color="primaryDark"
                      dark
                      @click:close="selectedFiles = []"
                      >{{ selectedFiles.length }}
                      {{ $t("documents.itemsSelected") }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-skeleton-loader
                  v-if="loadingDocuments"
                  type="table-thead, table-tbody"
                ></v-skeleton-loader>
                <agenda-documents-list-view
                  v-else
                  :files="documentsItems"
                  :search="search"
                  v-model="selectedFiles"
                  :defaultSortOrder="defaultSortOrder"
                ></agenda-documents-list-view>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="documentUploadDialog" persistent max-width="600px">
      <v-card flat>
        <v-toolbar color="pageHeader" flat dark height="50px">
          <v-btn icon large>
            <v-icon>mdi-cloud-upload</v-icon>
          </v-btn>

          <span>{{ $t("documents.uploadDocument") }}</span>
        </v-toolbar>
        <v-card-text v-cloak @drop.prevent="addDropFile" @dragover.prevent>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" lazy-validation>
                  {{ topicItems }}
                  <v-combobox
                    v-model="selectedTopics"
                    :items="topicItems"
                    item-text="topicName"
                    item-value="Id"
                    :label="$t('documents.selectTopics')"
                    :rules="[(v) => !!v || $t('documents.topicRequired')]"
                    required
                  ></v-combobox>
                  <upload-file
                    :files="uploadingFiles"
                    :icons="fileIcons"
                    v-on:add-files="addUploadingFiles"
                    v-on:remove-file="removeUploadingFile"
                  ></upload-file>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="pageHeader" text @click="onCloseDocumentUploadDialog">{{
            $t("btnClose")
          }}</v-btn>
          <v-btn
            :disabled="!valid"
            color="pageHeader"
            text
            @click="onDocumentUpload"
            >{{ $t("documents.upload") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm" />
  </v-container>
</template>

<script>
import AgendaDocumentsListView from "./AgendaDocumentsListView.vue";
import { formatBytes, createUUID } from "../../utils/util";
import { fileIcons } from "../../utils/constant";
import UploadFile from "./UploadFile.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import SearchInput from "../SearchInput.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import DocumentMixin from "./DocumentMixin";
import Loader from "@/components/Loader";
import _ from "lodash";
const imageMimeTypes = ["image/png", "image/jpeg"];

export default {
  components: {
    AgendaDocumentsListView,
    UploadFile,
    ConfirmDialog,
    SearchInput,
    Loader,
  },
  mixins: [SignalRMixin, DocumentMixin],
  name: "Agenda",
  data() {
    return {
      defaultSortOrder: null,
      loadingDocuments: false,
      sortedAgendaList: null,
      sortingType: "descending",
      loaderLoading: false,
      documentsItems: [],
      selectedFiles: [],
      valid: true,
      uploadingFiles: [],
      search: "",
      selectedItem: 0,
      selectedAgendaItem: null,
      documentUploadDialog: false,
      selectedTopics: null,
      documentFile: [],
      fileIcons,
      screenHeight: 0,
      listHeight: 0,
    };
  },
  computed: {
    ...mapState({
      documentsList: (state) => state.document.documentsList,
      agendaListData: (state) => state.document.agendaListForDocument,
    }),
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
    }),
    loaderText() {
      return this.$t("LoaderText");
    },
    topicItems() {
      return this.selectedAgendaItem ? this.selectedAgendaItem.topics : [];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    sortedList() {
      if (this.agendaListData.length) {
        const agendaListData = this.agendaListData.filter((item) => {
          if (
            this.$security.checkMeetingTypeAccess(
              item.meetingTypeId,
              "ViewMeeting"
            ) &&
            this.$security.checkMeetingTypeAccess(
              item.meetingTypeId,
              "OpenMeetingDocument"
            )
          ) {
            return item;
          }
        });
        if (this.sortingType === "ascending") {
          return _.orderBy(
            agendaListData,
            [(agenda) => agenda.agendaName.toLowerCase()],
            ["desc"]
          );
        } else if (this.sortingType === "descending") {
          return _.orderBy(
            agendaListData,
            [(agenda) => agenda.agendaName.toLowerCase()],
            ["asc"]
          );
        } else {
          return agendaListData;
        }
      }
      return [];
    },
  },
  watch: {
    async sortedList(value) {
      if (value.length) {
        await this.bindAgendaDocuments(value);
      }
    },
  },
  methods: {
    ...mapActions({
      getDocumentsList: "document/getDocumentsList",
      getDocumentsByAgendaId: "document/getDocumentsByAgendaId",
      createDocuments: "document/createDocuments",
      deleteDocuments: "document/deleteDocuments",
      downloadDocumentAPI: "document/downloadDocument",
      getAgendaListApi: "document/getAgendaListForDocument",
    }),
    onAgendaItemClick,
    onOpenDocumentUploadDialog,
    onCloseDocumentUploadDialog,
    onDocumentUpload,
    addUploadingFiles,
    addFiles,
    formatBytes,
    removeUploadingFile,
    addDropFile,
    downloadDocument,
    getDocumentListByAgendaId,
    onDeleteDocuments,
    confirmDelete,
    createUUID,
    signalRInit,
    bindAgendaDocuments,
    sortingAgenda,
    onResize() {
      this.screenHeight = window.innerHeight - 150;
      this.listHeight = window.innerHeight - 200;
    },
  },
  mounted,
};

function sortingAgenda() {
  if (this.sortingType === "ascending") {
    this.sortingType = "descending";
  } else if (this.sortingType === "descending") {
    this.sortingType = "ascending";
  }
  this.selectedFiles = [];
  this.selectedItem = 0;
}
async function bindAgendaDocuments(items) {
  if (items.length) {
    this.selectedAgendaItem = items[this.selectedItem];
    if (this.selectedAgendaItem) {
      await this.getDocumentListByAgendaId(this.selectedAgendaItem);
    }
  }
}

function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    if (!_.isEmpty(message) && this.selectedAgendaItem) {
      await this.getAgendaListApi();
      await this.getDocumentListByAgendaId(this.selectedAgendaItem);
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function onDeleteDocuments() {
  const answer = await this.confirmDelete();
  if (answer) {
    const promises = [];
    this.selectedFiles.forEach((files) => {
      promises.push(this.deleteDocuments(files.documentId));
    });
    await Promise.all(promises);
    await this.getDocumentListByAgendaId(this.selectedAgendaItem);
  }
}

async function getDocumentListByAgendaId(item) {
  try {
    this.loadingDocuments = true;
    const documents = await this.getDocumentsByAgendaId(item.id);
    this.documentsItems = documents.map((doc) => ({
      ...doc,
      topicName: getTopicName(doc, item),
      meetingTypeId: item.meetingTypeId,
    }));
    this.loadingDocuments = false;
  } catch (error) {
    this.loadingDocuments = false;
  }
}
function getTopicName(document, agenda) {
  if (!document.topicid) {
    return "-";
  }
  let topic = agenda.topics.find((t) => t.Id === document.topicid);
  if (topic) {
    return topic.topicName;
  }
  return "-";
}

function downloadDocument() {
  this.selectedFiles.forEach(async (file) => {
    const params = {
      documentId: file.documentId,
      filename: file.fileName,
    };
    const res = await this.downloadDocumentAPI(params);
    let contentType = res.headers["content-type"];
    let blob = new Blob([res.data], { type: contentType });
    let url = window.URL.createObjectURL(blob);
    let docUrl = document.createElement("a");
    docUrl.href = url;
    docUrl.setAttribute("download", file.fileName);
    document.body.appendChild(docUrl);
    docUrl.click();
  });
}
function addDropFile(e) {
  if (e.dataTransfer.files) {
    this.addFiles(e.dataTransfer.files);
  }
}

function removeUploadingFile(index) {
  this.uploadingFiles.splice(index, 1);
}

function addFiles(files) {
  if (files.length) {
    this.addUploadingFiles(files);
    this.$refs.inputUpload.reset();
  }
}

async function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles.push(...files);
}

function onCloseDocumentUploadDialog() {
  this.$refs.form.reset();
  this.$refs.form.resetValidation();
  this.documentUploadDialog = false;
}

async function onDocumentUpload() {
  if (this.$refs.form.validate()) {
    const promises = [];
    let formData;
    this.uploadingFiles.forEach(async (item) => {
      formData = new FormData();
      formData.append("tenantId", sessionStorage.getItem("tenantId"));
      formData.append("topicId", this.selectedTopics.Id);
      formData.append("documentId", createUUID());
      formData.append("meetingId", "testmeeting");
      formData.append("agendaId", this.selectedAgendaItem.id);
      formData.append("directoryId", "");
      formData.append("peopleId", "");
      formData.append("attachment", item);
      promises.push(this.createDocuments(formData));
    });

    await Promise.all(promises);
    await this.getDocumentListByAgendaId(this.selectedAgendaItem);
    this.$refs.form.reset();
    this.$refs.form.resetValidation();
    this.documentUploadDialog = false;
  }
}

function onOpenDocumentUploadDialog() {
  this.selectedTopics = null;
  this.uploadingFiles = [];
  this.documentUploadDialog = true;
}

async function mounted() {
  try {
    this.loaderLoading = true;
    this.loadingDocuments = true;
    await this.getAgendaListApi();
    this.loaderLoading = false;
    this.signalRInit(`meeting_${this.selectedTenant}`);
    this.initializeSortDataAndSignalR("5fae1073-91c2-4bf6-881b-352f5aa76afa");
    this.loadingDocuments = false;
  } catch (error) {
    this.loaderLoading = false;
    this.loadingDocuments = false;
  }
}

async function onAgendaItemClick(item) {
  this.selectedFiles = [];
  this.selectedAgendaItem = item;
  await this.getDocumentListByAgendaId(item);
}

async function confirmDelete() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}
</script>

<style scoped>
.title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px;
  color: #ffffff !important;
}
.agenda-list {
  background: #ffffff;
  border-width: 1px 0px;
  border-style: solid;
  border-color: var(--v-secondary-base);
  height: 40px;
  min-height: 40px;
  font-family: "Noto Sans JP";
  font-size: 16px;
  color: var(--v-darkCharcoal-base) !important;
}
.agenda-list /deep/ .v-list-item__content {
  line-height: 21px !important;
}
::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}
::v-deep .v-btn__content {
  text-transform: none;
  font-size: 0.875rem;
  font-weight: normal;
  font-family: unset;
}
/* default split bar color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-primaryDark2-base) !important;
  z-index: 1 !important;
  margin-left: 1px;
  margin-right: 1px;
}
.splitterContent
  /deep/
  .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}
/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-primary-base) !important;
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-primary-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-resize-handler,
.e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-active
  .e-resize-handler {
  color: var(--v-primaryDark-base);
}
</style>